import React, { useEffect, useRef, useState } from 'react';
import API_BASE_URL from "../../../apiConfig";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { jsPDF } from "jspdf";
import "jspdf-autotable";

const PANObjectAdminReport = () => {
    const [panObjectData, setPanObjectData] = useState([]);
    const tableRef = useRef(null);

    useEffect(() => {
        const fetchPanObjectData = async () => {
            try {
                // Retrieve token from localStorage or sessionStorage
                const authToken = localStorage.getItem("authToken"); // or sessionStorage.getItem('token')

                const response = await fetch(`${API_BASE_URL}/PanObject/GetPanObjectRecords`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${authToken}`, // Attach token in the request

                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                let data = await response.json();

                // Add SrNo property to each record
                data = data.map((record, index) => ({
                    ...record,
                    SrNo: index + 1 // Auto-incrementing SrNo
                }));

                setPanObjectData(data); // Update state with modified data
            } catch (error) {
                console.error('Failed to fetch publication records:', error);
            }
        };

        fetchPanObjectData();
    }, []);

    console.log(panObjectData);

    // Function to update status
    const handleStatusChange = async (registrationNo, newStatus) => {
        const comment = prompt("Enter comment for this status change:");
        if (!comment) return; // Optional: require comment

        try {
            const authToken = localStorage.getItem("authToken");

            const response = await fetch(`${API_BASE_URL}/PanObject/updateStatus/${registrationNo}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify({ status: newStatus, comment }),
            });

            if (!response.ok) throw new Error("Failed to update ticket status");

            // Update UI state
            setPanObjectData(prev =>
                prev.map(row =>
                    row.registrationNo === registrationNo
                        ? { ...row, status: newStatus, comment }
                        : row
                )
            );

        } catch (error) {
            console.error("Error updating ticket status:", error);
        }
    };


    useEffect(() => {
        if (tableRef.current && panObjectData.length > 0) {
            const table = $(tableRef.current).DataTable({
                destroy: true, // Destroy existing table instance
                data: panObjectData,
                columns: [
                    { data: 'SrNo', title: 'Sr No' }, // Dynamically added field
                    { data: 'startDate', title: 'Date' }, // Matches 'startDate'
                    { data: 'applicantName', title: 'Applicant Name' }, // Matches 'name'
                    { data: 'registrationNo', title: 'Registration No' }, // Matches 'registrationNo'
                    {
                        data: 'status',
                        title: 'Status',
                        render: function (data, type, row) {
                            return `
                  <select class="form-control status-dropdown" data-id="${row.registrationNo}">
                    <option value="In Progress" ${data === "In Progress" ? "selected" : ""}>In Progress</option>
                    <option value="Complete" ${data === "Complete" ? "selected" : ""}>Complete</option>
                    <option value="Rejected" ${data === "Rejected" ? "selected" : ""}>Rejected</option>
                    <option value="Refunded" ${data === "Refunded" ? "selected" : ""}>Refunded</option>
                    </select>
                `;
                        }
                    },
                    { data: 'comment', title: 'Comment' },
                    {
                        data: null,
                        title: "Submitted Form",
                        render: function (data, type, row) {
                            return `<button class='btn btn-sm btn-primary download-btn' data-id='${row.registrationNo}'>Download PDF</button>`;
                        },
                    },
                    {
                        data: null,
                        title: "Document",
                        render: function (data, type, row) {
                            return `<button class='btn btn-sm btn-success download-doc-btn' data-id='${row.registrationNo}'>Download</button>`;
                        },
                    }
                ]
            });

            // Handle download button click
            $('#productsTable tbody').off('click', '.download-btn').on('click', '.download-btn', function () {
                const registrationNo = $(this).data("id");
                downloadPDF(registrationNo, "form");
            });

            $('#productsTable tbody').off('click', '.download-doc-btn').on('click', '.download-doc-btn', function () {
                const registrationNo = $(this).data("id");
                downloadPDF(registrationNo, "document");
            });

            // Handle status change
            $(tableRef.current).on("change", ".status-dropdown", function () {
                const registrationNo = $(this).attr("data-id");
                const newStatus = $(this).val();
                const comment = ""; // Or however you get it
                handleStatusChange(registrationNo, newStatus, comment);
            });

            return () => {
                table.destroy();
                $(tableRef.current).off("change", ".status-dropdown");
            };
        }
    }, [panObjectData])


    const downloadPDF = async (registrationNo, type) => {
        try {
            const authToken = localStorage.getItem("authToken");
            // const endpoint = type === "form"
            //     ? `http://localhost:5121/api/PanObject/DownloadPdf/${registrationNo}`
            //     : `http://localhost:5121/api/PanObject/DownloadDocument/${registrationNo}`;

            const endpoint = type === "form"
                ? `${API_BASE_URL}/PanObject/DownloadPdf/${registrationNo}`
                : `${API_BASE_URL}/PanObject/DownloadDocument/${registrationNo}`;

            const response = await fetch(endpoint, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (!response.ok) {
                throw new Error(`Failed to download file: ${response.status}`);
            }

            const blob = await response.blob();
            const contentType = response.headers.get("Content-Type");

            // Determine file extension from MIME type
            const fileExtension = contentType.split("/")[1]; // Example: 'image/png' → 'png'

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `PanObject_${type}_${registrationNo}.${fileExtension}`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } catch (error) {
            console.error("Download error:", error);
        }
    };

    return (

        <table
            ref={tableRef}
            id="productsTable"
            className="table table-bordered table-hover table-product"
            style={{ width: '100%' }}
        >
            <thead>
                <tr>
                    <th>Sr. No.</th>
                    <th>Date</th>
                    <th>Applicant Name</th>
                    <th>Registration No</th>
                    <th>Status</th>
                    <th>Comment</th>
                    <th>Submitted Form</th>
                    <th>Document</th>
                </tr>
            </thead>
        </table>

    );
};


export default PANObjectAdminReport;